import { __awaiter } from '../../../_virtual/_tslib.js';
import { UpdateAssetDuration } from '../../usecases/update-asset-duration.js';
import { useUpdateAsset } from './use-update-asset.js';

/**
 * @todo it could be better done in the backend
 * @description When the user uploads an asset image or video during the post creation page update asset size and duration.
 */
const useUpdateAssetDuration = () => {
  const updateAsset = useUpdateAsset();
  const mutateAsync = (assetId, assetFile) => __awaiter(void 0, void 0, void 0, function* () {
    const assetDurationPayload = yield new UpdateAssetDuration().execute(assetId, assetFile);
    if (!assetDurationPayload) return;
    updateAsset.mutateAsync({
      payload: assetDurationPayload
    });
  });
  return {
    mutateAsync
  };
};

export { useUpdateAssetDuration };
